import { EyeInvisibleOutlined, EyeTwoTone, ExclamationCircleFilled } from '@ant-design/icons'
import { Col, Form, Menu, Modal, Row, Switch, Tabs, Tooltip } from 'antd'
import Avatar from 'components/Avatar'
import Button from 'components/Button/index'
import Control from 'components/Control/Control'
import Flex from 'components/Flex'
import AntdInput from 'components/Form/Input'
import Password from 'components/Form/Password'
import AntdSelect from 'components/Form/Select'
import Camera from 'components/icons/Camera'
import Check from 'components/icons/CheckCircleIcon'
import Emptystates from 'components/icons/emptystates.svg'
import phonestates from 'components/icons/phonestates.svg'
import Party from 'components/images/party.png'
import Input from 'components/Input/Input'
import Label from 'components/Label/Label'
import Uploader from 'components/Uploader/Uploader'
import { setUserPreference } from 'modules/ManageProfile/actions'
import instituteRequest from 'utils/instituteRequest'
import {
  ButtonCenterPadding,
  Content,
  DisplayPad,
  FormItem,
  ImageColPadding,
  ImageTag,
  ImageUploadWrapper,
  InputLabel,
  LabelColPadding,
  Learn,
  MailHeading,
  MailSubHeading,
  MessageDiv,
  NoteText,
  PasswordInput,
  PendingIcon,
  RowPadding,
  SectionWrapper,
  SpanTest,
  SplitFlex,
  StyledDivider,
  StyledDividerTab,
  StyledInput,
  StyledInputDiv,
  StyledMenu,
  StyledSelectDiv,
  StyledSpan,
  TopHeader,
  TopHeading,
} from 'modules/ManageProfile/Style/style'
import {
  deleteFile,
  setResumeData,
  updateNotification,
} from 'modules/Onboarding/actions'
import {
  InputGroup,
  OTPButton,
  OtpDiv,
  OTPHeading,
  OTPMessage,
  Span,
  SpanBold,
} from 'modules/Onboarding/Components/ActivateAccount/CheckOtpPage/style'
import React, { Fragment, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { IsValidEmail } from 'utils/emailValidation'
import { encrypt } from 'utils/encrypt'
import ErrorMessage from 'utils/ErrorMessage'
import { validatePassword } from 'utils/passwordValidation'
import { removeDuplicatesFromArray } from 'utils/removeDuplicatesFromArray'
import SuccessMessage from 'utils/SuccessMessage'
import SuccessIcon from '../../components/icons/SuccessIcon'
import ActionRoleDrawer from '../../components/UIElements/ActionRoleDrawer'
import SuccessModal from '../../components/UIElements/ActionRoleDrawer/SuccessModal'
import { actionDrawerProps, OPT_OUT_CONFIG } from '../../utils/constants'
import { permittedEventCruds } from '../../utils/permissionsValidation'
import { AntdText, InnerWrapper, StyledCard } from './Style/style'
const { TabPane } = Tabs

const ManageProfile = ({
  studentFormData,
  getStudentData,
  updateStudentData,
  updateStudentProfile,
  changePassword,
  getUserPreference,
  UserPreference,
  SendOtp,
  checkEmailOtp,
  checkPhoneOtp,
  getListOfCountries,
  listOfCountries,
  permissions,
  getNotificationCatalogues,
  sendNotificationEmail,
  studentOptedStatus,
  updateOptedStatus,
  updateOptedWitdrawStatus,
  optoutStatus,
  getPendingData,
  getFrozenFields,
  pendingData,
  frozenFields,
}) => {
  const [countryCode, setCountryCode] = useState('91')
  const [actionDrawer, setActionDrawer] = useState(false)
  const [tpoConfig, setTpoConfig] = useState(null)
  const [frozenFieldsLocal, setFrozenFieldsLocal] = useState({})
  // const isOptOut = 'pending'
  // const isOptOut = optoutStatus?.optoutStatus?.optedStatusText
  const isOptOut = optoutStatus?.optoutStatus?.optedStatusText?.replace(
    /\s+/g,
    ''
  )
      const campusDetails = useSelector(state => state?.studentData?.campusDetails)
      const accessLevel = campusDetails?.instituteSubscription?.accessLevel
  const currentStatus = isOptOut ?? 'default'
  const [successModal, setSuccessModal] = useState(false)
  const [confirmationModal, setConfirmationModal] = useState(false)
  const [countryCodeList, setCountryCodeList] = useState([])
  const navigate = useNavigate()

  const actionHandlers = {
    showSuccessModal: () => {
      //setSuccessModal(true)
      setConfirmationModal(true)
      // const payload = {
      //   isOptOut: false,
      // }
      // updateOptedWitdrawStatus(payload)
      // studentOptedStatus()
      // setActionDrawer(false)
    },
    optInProcess: () => {
      setSuccessModal(true)
      const payload = {
        isOptOut: false,
      }
      updateOptedStatus(payload)
    },
    openDrawer: () => {
      setActionDrawer(true)
    },
  }
  const handleConfirm = () => {
    setSuccessModal(true)
    setConfirmationModal(false)
    const payload = {
      isOptOut: false,
    }
    updateOptedWitdrawStatus(payload)
  }
  const handleCloseDrawer = () => {
    setSuccessModal(false)
    setConfirmationModal(false)
  }
  const {
    message,
    actionText,
    variant,
    borderColor,
    statusMessage,
    actionType,
  } = OPT_OUT_CONFIG[currentStatus] || OPT_OUT_CONFIG['default']

  const OptoutButton = Button?.[variant]
  useEffect(() => {
    getStudentData()
    getUserPreference(stdData?.admin?._id)
    getCountryCodes('')
    studentOptedStatus()
    getPendingData()
  }, [])

  useEffect(() => {
    const fetchTpoConfig = async () => {
      try {
        const instituteCampusId = studentFormData?.student?.instituteCampusId
        if (instituteCampusId) {
          const response = await instituteRequest.get(
            `/institutes/${instituteCampusId}/tpo-approval-config`
          )
          if (response?.data?.data) {
            console.log(response.data.data,"config")
            setTpoConfig(response.data.data)
          }
        }
      } catch (error) {
        console.error('Error fetching TPO config:', error)
      }
    }
    fetchTpoConfig()
  }, [studentFormData?.student?.instituteCampusId])

  useEffect(() => {
    let config = tpoConfig
    if (!config || !config.tpoApprovalConfig || !config.tpoApprovalConfig.fields || !config.isRequestForTPOApproval) {
      setFrozenFieldsLocal({})
      return
    }

    const frozen = {}
    const fields = config.tpoApprovalConfig.fields
    
    // Map field names to their config keys
    const fieldMapping = {
      firstName: 'firstName',
      lastName: 'lastName',
      email: 'primaryEmail',
      phoneNumber: 'phoneNumber'
    }
    
    Object.keys(fieldMapping).forEach((field) => {
      const configKey = fieldMapping[field]
      const fieldConfig = fields[configKey]
      
      if (fieldConfig && (fieldConfig.freezeAfterApproval || fieldConfig.freezeAfterVerification)) {
        let fieldValue = studentFormData?.admin?.[field]
        
        const hasValue = fieldValue !== null && fieldValue !== undefined && fieldValue !== ''
        
        if (hasValue) {
          frozen[field] = true
        }
      }
    })

    setFrozenFieldsLocal(frozen)
  }, [tpoConfig, studentFormData?.admin])

  const formRef = React.createRef()
  let stdData = useSelector(state => state?.studentData?.studentDetails)

  const getCountryCodes = async searchValue => {
    const { data, status } = await getListOfCountries({
      phoneCodeSearch: searchValue,
      pageLimit: 50,
    })
    if (status >= 200 && status <= 300) {
      let updatedData = removeDuplicatesFromArray(
        data?.data?.countries,
        'phone_code'
      )
      setCountryCodeList(updatedData)
    } else {
      setCountryCodeList([])
    }
  }

  const dispatch = useDispatch()
  const [form] = Form.useForm()
  const [formPwd] = Form.useForm()
  const [formsetting] = Form.useForm()
  const [otpChangeForm] = Form.useForm()
  const [file, setFile] = useState(null)
  const submitkey = 'profileForm'
  const [tab, setTab] = useState('profile')
  const [enteredEmail, setEnteredEmail] = useState('')
  const [enteredPhone, setEnteredPhone] = useState()
  const [emailModel, setEmailModel] = useState(false)
  const [emailOTP, setEmailOTP] = useState(false)
  const [emailVerify, setEmailVerify] = useState(false)
  const [phoneModel, setPhoneModel] = useState(false)
  const [phoneOTP, setPhoneOTP] = useState(false)
  const [phoneVerify, setPhoneVerify] = useState(false)
  const [email, setEmail] = useState()
  const [whatsapp, setWhatsapp] = useState()

  const [otpEmail, setOtpEmail] = useState({
    otp1: '',
    otp2: '',
    otp3: '',
    otp4: '',
  })

  const [otpSMS, setOtpSMS] = useState({
    otp1: '',
    otp2: '',
    otp3: '',
    otp4: '',
  })
  const [errmsg, setErrmsg] = useState(null)
  const [passwordTemplate, setPasswordTemplate] = useState(null)
  const permittedEvents = permittedEventCruds(permissions, 'MANAGE PROFILE')

  const ChangePassword =
    permittedEvents?.find(item => item.events?.eventName === 'ACTION')
      ?.events || ''

  useEffect(() => {
    ;(async () => {
      if (ChangePassword?.id) {
        let responce = await getNotificationCatalogues(ChangePassword?.id)
        const filteredArray = responce?.CatalogueData?.filter(
          item =>
            item.eventNotificationTemplate &&
            item.eventNotificationTemplate.templateName ===
              'Credentials Notification' &&
            item.eventNotificationTemplate.eventNotificationType &&
            item.eventNotificationTemplate.eventNotificationType.name ===
              'E-Mail'
        )

        if (filteredArray?.length > 0) {
          setPasswordTemplate(filteredArray[0].eventNotificationTemplate)
        }
      }
    })()

    return () => {
      // this now gets called when the component unmounts
    }
  }, [ChangePassword])

  useEffect(() => {
    if (otpEmail?.otp1 && otpEmail?.otp2 && otpEmail?.otp3 && otpEmail?.otp4) {
      otpEmailCheck()
    }
  }, [otpEmail])
  useEffect(() => {
    if (otpSMS?.otp1 && otpSMS?.otp2 && otpSMS?.otp3 && otpSMS?.otp4) {
      otpSMSCheck()
    }
  }, [otpSMS])

  const clickEventEmail = (position, e) => {
    if (position !== 'last' && e.target.value) {
      document.getElementById(position).focus()
    }
    if (position === 'sec') {
      setOtpEmail({ ...otpEmail, otp1: e.target.value })
    } else if (position === 'third') {
      setOtpEmail({ ...otpEmail, otp2: e.target.value })
    } else if (position === 'fourth') {
      setOtpEmail({ ...otpEmail, otp3: e.target.value })
    } else {
      setOtpEmail({ ...otpEmail, otp4: e.target.value })
    }
  }

  const emailOTPKeyDown = (position, e) => {
    if (e.keyCode === 8 && position !== '1st') {
      // Backspace key is pressed and it's not the first input field
      const prevPositionNumber = getPrevPositionNumber(position)
      const prevPosition = getPrevPosition(position)
      if (position == 'fourth' && otpEmail.otp4) {
        setOtpEmail(prevOtp => ({
          ...prevOtp,
          ['otp4']: '',
        }))
      } else {
        document.getElementById(prevPosition).focus()
        setOtpEmail(prevOtp => ({
          ...prevOtp,
          ['otp' + prevPositionNumber]: '',
          ['otp' + (prevPositionNumber + 1)]: '',
        }))
      }
    }
  }

  const clickEventSMS = (position, e) => {
    if (position !== 'last' && e.target.value) {
      document.getElementById(position).focus()
    }
    if (position === 'sec') {
      setOtpSMS({ ...otpSMS, otp1: e.target.value })
    } else if (position === 'third') {
      setOtpSMS({ ...otpSMS, otp2: e.target.value })
    } else if (position === 'fourth') {
      setOtpSMS({ ...otpSMS, otp3: e.target.value })
    } else {
      setOtpSMS({ ...otpSMS, otp4: e.target.value })
    }
  }
  const phoneOTPKeyDown = (position, e) => {
    if (e.keyCode === 8 && position !== '1st') {
      // Backspace key is pressed and it's not the first input field
      const prevPositionNumber = getPrevPositionNumber(position)
      const prevPosition = getPrevPosition(position)
      if (position == 'fourth' && phoneOTP.otp4) {
        setOtpSMS(prevOtp => ({
          ...prevOtp,
          ['otp4']: '',
        }))
      } else {
        document.getElementById(prevPosition).focus()
        setOtpSMS(prevOtp => ({
          ...prevOtp,
          ['otp' + prevPositionNumber]: '',
          ['otp' + (prevPositionNumber + 1)]: '',
        }))
      }
    }
  }

  const getPrevPositionNumber = currentPosition => {
    switch (currentPosition) {
      case 'sec':
        return 1
      case 'third':
        return 2
      case 'fourth':
        return 3
      default:
        return 0
    }
  }
  const getPrevPosition = currentPosition => {
    switch (currentPosition) {
      case 'sec':
        return '1st'
      case 'third':
        return 'sec'
      case 'fourth':
        return 'third'
      default:
        return ''
    }
  }
  const otpEmailCheck = async () => {
    let otpNum = `${otpEmail?.otp1}${otpEmail?.otp2}${otpEmail?.otp3}${otpEmail?.otp4}`
    let payLoad = {
      otp: otpNum,
      newEmail: enteredEmail,
      checkForApproval: true,
      instituteCampusId: studentFormData?.student?.instituteCampusId,
    }
    let response = await checkEmailOtp(stdData?.admin?._id, payLoad)
    if (response?.data?.message?.data === 'Email update request submitted for TPO approval') {
       setEmailVerify(true)
      setEmailOTP(false)
      setErrmsg(null)
      getPendingData()
    }else if (response?.data?.message?.success === true) {
      let dataUpdate = {
        admin: {
          ...studentFormData?.admin,
          email: enteredEmail,
        },
        student: studentFormData?.student,
        studentPersonalProfile: studentFormData?.studentPersonalProfile,
        currentCourse: studentFormData?.currentCourse,
        education: studentFormData?.education || [],
        resume: studentFormData?.resume,
      }
      dispatch(setResumeData(dataUpdate))
      setEmailVerify(true)
      setEmailOTP(false)
      setErrmsg(null)
    } else {
      setOtpEmail({ otp1: '', otp2: '', otp3: '', otp4: '' })
      setErrmsg('Incorrect OTP')
    }
  }
  const otpSMSCheck = async () => {
    let otpNum = `${otpSMS?.otp1}${otpSMS?.otp2}${otpSMS?.otp3}${otpSMS?.otp4}`

    let payLoad = {
      otp: otpNum,
      newPhoneNumber: enteredPhone,
      country_code: countryCode,
      checkForApproval: true,
      instituteCampusId: studentFormData?.student?.instituteCampusId,
    }
    let response = await checkPhoneOtp(stdData?.admin?._id, payLoad)

    if (response?.data?.message?.data === 'Phone number update request submitted for TPO approval') {
      setPhoneVerify(true)
      setPhoneOTP(false)
      setPhoneErrmsg(null)
      getPendingData()
    } else if (response?.data?.message?.success === true) {
      let dataUpdate = {
        admin: {
          ...studentFormData?.admin,
          phoneNumber: enteredPhone,
        },
        student: studentFormData?.student,
        studentPersonalProfile: studentFormData?.studentPersonalProfile,
        currentCourse: studentFormData?.currentCourse,
        education: studentFormData?.education || [],
        resume: studentFormData?.resume,
      }
      dispatch(setResumeData(dataUpdate))
      setPhoneVerify(true)
      setPhoneOTP(false)
      setErrmsg(null)
    } else {
      setErrmsg('Incorrect OTP')
    }
  }

  const onChnageSendOtpEmail = async () => {
    setOtpEmail({
      otp1: '',
      otp2: '',
      otp3: '',
      otp4: '',
    })
    setErrmsg('')
  }
  const onChangeSendOtpSMS = async () => {
    let payLoad = {
      newEmail: '',
      newPhone: enteredPhone,
      country_code: countryCode,
    }
    let callBack = msg => {
      if (msg == 'success') {
        // setEmailModel(false)
        // setEmailOTP(true)
      }
    }
    SendOtp(stdData?.admin?._id, payLoad, callBack)
  }
  const handleApprove = (value, reason) => {
    const payload = {
      isOptOut: true,
      optoutType: value,
      optoutReason: reason,
    }
    updateOptedStatus(payload)
    studentOptedStatus()
  }
  const handleClose = () => {
    setActionDrawer(false)
  }
  useEffect(() => {
    // Check for pending data and use it if available, otherwise use current data
    const firstName = (pendingData?.firstName?.value && pendingData?.firstName?.value !== studentFormData?.admin?.firstName) 
      ? pendingData?.firstName?.value 
      : studentFormData?.admin?.firstName
    
    const lastName = (pendingData?.lastName?.value && pendingData?.lastName?.value !== studentFormData?.admin?.lastName) 
      ? pendingData?.lastName?.value 
      : studentFormData?.admin?.lastName
    
    const email = (pendingData?.studentPersonalProfile?._pendingFields?.primaryEmail?.value && pendingData?.studentPersonalProfile?._pendingFields?.primaryEmail?.value !== studentFormData?.admin?.email) 
      ? pendingData?.studentPersonalProfile?._pendingFields?.primaryEmail?.value 
      : studentFormData?.admin?.email
    
    const phoneNumber = (pendingData?.studentPersonalProfile?._pendingFields?.phoneNumber?.value && pendingData?.studentPersonalProfile?._pendingFields?.phoneNumber?.value !== studentFormData?.admin?.phoneNumber) 
      ? pendingData?.studentPersonalProfile?._pendingFields?.phoneNumber?.value 
      : studentFormData?.admin?.phoneNumber

    form.setFieldsValue({
      firstName,
      lastName,
      profileUrl: studentFormData?.student?.profileUrl,
      email,
      countryCode: studentFormData?.admin?.countryCode,
      phoneNumber,
    })
    setCountryCode(studentFormData?.admin?.countryCode)
    setFile(studentFormData?.student?.profileUrl || null)
  }, [studentFormData, pendingData])

  useEffect(() => {
    formsetting.setFieldValue({
      whatsapp: UserPreference?.notification_subscription?.whatsapp ?? false,
      email: UserPreference?.notification_subscription?.email ?? false,
    })

    setEmail(UserPreference?.notification_subscription?.email ?? false)
    setWhatsapp(UserPreference?.notification_subscription?.whatsapp ?? false)
  }, [UserPreference])
  const onRemoveImage = async () => {
    let response = deleteFile(file)
    if (response) {
      setFile(null)
      form.setFieldsValue({ profileUrl: '' })
      SuccessMessage('File deleted successfully!')
    } else {
      ErrorMessage('Failed to delete the file!')
    }
  }
  useEffect(() => {
    form.setFieldsValue({ profileUrl: file })
  }, [file])

  const onCountryCodeChange = data => {
    setCountryCode(data)
  }

  const onEmailEntered = e => {
    setEnteredEmail(e.target.value)
  }

  const onPhoneEntered = e => {
    setEnteredPhone(e.target.value)
  }

  const submitHandler1 = async values => {
    let payload = {
      profileUrl: values?.profileUrl,
      firstName: values?.firstName.replace(/^(?:\s+|\s+)$/gm, ''),
      lastName: values?.lastName,
      checkForApproval: true,
      instituteCampusId: studentFormData?.student?.instituteCampusId,
    }
    
    let response = await updateStudentProfile(payload)
    
    if (response?.success === true) {
      await getStudentData()
      await getPendingData()
      SuccessMessage('Personal info saved successfully!')
    } else {
      ErrorMessage(response?.response?.data?.message)
    }
  }
  const submitHandler2 = async values => {
    let payload = {
      currentPassword: await encrypt(values.currentPwd),
      newPassword: await encrypt(values.newPwd),
    }
    if (values.confirmPwd === values.newPwd) {
      let response = await changePassword(stdData?.admin?._id, payload)
      if (response === true) {
        if (passwordTemplate) {
          let name = stdData?.firstName + ' ' + stdData?.lastName
          let template
          template = passwordTemplate?.templateText.replace('{userName}', name)
          let mailObj = {
            to: stdData?.admin?.email,
            subject:
              passwordTemplate?.subject ||
              'Your Account  is Activated - Pluginlive',
            htmlBody: template,
          }
          sendNotificationEmail(mailObj, false)
        }
        formPwd.resetFields()
        SuccessMessage('Password Changed Successfully')
      } else {
        // Handle different error scenarios
        let errorMessage = response?.response?.data?.message?.message || 
                          response?.response?.data?.message || 
                          response?.message || 
                          'Invalid current password'
        
        // Check if it's a 400 status code error (wrong current password)
        if (response?.response?.status === 400 || 
            errorMessage.includes('AxiosError: Request failed with status code 400')) {
          errorMessage = "User's Current Password is Incorrect"
        }
        
        // Display the error message
        ErrorMessage(errorMessage)
        
        // Also set field-level error for current password field
        if (errorMessage.toLowerCase().includes('current password') || 
            errorMessage.toLowerCase().includes('invalid') ||
            errorMessage.toLowerCase().includes('incorrect')) {
          formRef.current.setFields([
            {
              name: 'currentPwd',
              errors: ["User's Current Password is Incorrect"],
            },
          ])
        }
      }
    } else {
      formRef.current.setFields([
        {
          name: 'confirmPwd',
          errors: ['Password doesn’t match'],
        },
      ])
    }
  }

  const onChangeEmail = () => {
    formsetting.setFieldsValue({ email: !email })
    setEmail(!email)
  }
  const onChangeWhatsapp = () => {
    formsetting.setFieldsValue({ whatsapp: !whatsapp })
    setWhatsapp(!whatsapp)
  }
  const submitHandler3 = async values => {
    // Use the current state values for email and whatsapp
    const currentEmail = email
    const currentWhatsapp = whatsapp
    
    let dataSet = {
      ...UserPreference,
      notification_subscription: {
        ...UserPreference?.notification_subscription,
        email: currentEmail,
        whatsapp: currentWhatsapp,
      },
    }

    let payload = {
      email: currentEmail,
      whatsapp: currentWhatsapp,
    }
    
    // Wait for the update to complete
    const result = await dispatch(updateNotification(stdData?.admin?._id, payload))
    
    console.log('Update result:', result)
    console.log('=================================')
    
    if (result === true) {
      // Update local state
      dispatch(setUserPreference(dataSet))
      
      // Refresh user preferences from server to ensure data is in sync
      await dispatch(getUserPreference(stdData?.admin?._id))
      
      navigate(`/dashboard`)
    } else {
      console.error('Failed to update notification preferences')
    }
  }
  const changeMail = () => {
    if (frozenFieldsLocal?.email) {
      ErrorMessage('Email is frozen and cannot be changed')
      return
    }
    setEmailModel(true)
  }
  const changePhone = () => {
    if (frozenFieldsLocal?.phoneNumber) {
      ErrorMessage('Phone number is frozen and cannot be changed')
      return
    }
    setPhoneModel(true)
    otpChangeForm.setFieldsValue({
      country_code: studentFormData?.admin?.countryCode,
    })
  }
  const changeTab = e => {
    setTab(e.key)
  }
  const handleEmailCancel = () => {
    setEmailModel(false)
    setEnteredEmail('')
  }
  const handleEmailOTPCancel = () => {
    setEmailOTP(false)
    setEnteredEmail('')

    setOtpEmail({
      otp1: '',
      otp2: '',
      otp3: '',
      otp4: '',
    })
  }
  const handleEmailVerifyCancel = () => {
    setEmailVerify(false)
    setEnteredEmail('')
    setOtpEmail({
      otp1: '',
      otp2: '',
      otp3: '',
      otp4: '',
    })
  }
  const handlePhoneOTPCancel = () => {
    setPhoneOTP(false)
    setEnteredPhone('')
    otpChangeForm.setFieldValue('Phone', '')
    setOtpSMS({
      otp1: '',
      otp2: '',
      otp3: '',
      otp4: '',
    })
  }
  const handlePhoneVerifyCancel = () => {
    setPhoneVerify(false)
    getStudentData()
    setEnteredPhone('')
    otpChangeForm.setFieldValue('Phone', '')
    setOtpSMS({
      otp1: '',
      otp2: '',
      otp3: '',
      otp4: '',
    })
  }
  const handlePhoneCancel = () => {
    setPhoneModel(false)
    setEnteredPhone('')
    otpChangeForm.setFieldValue('Phone', '')
  }
  const sendEmailOTP = async values => {
    if (enteredEmail === studentFormData?.admin?.email) {
      ErrorMessage('Entered Email ID Should not be same as Current Email ID')
    } else {
      let payLoad = {
        newEmail: enteredEmail,
        newPhone: '',
      }
      let callBack = msg => {
        if (msg == 'success') {
          setEmailModel(false)
          setEmailOTP(true)
        }
      }
      SendOtp(stdData?.admin?._id, payLoad, callBack)
    }
  }

  const sendPhoneOTP = async values => {
    if (enteredPhone === studentFormData?.admin?.phoneNumber) {
      ErrorMessage(
        'Entered Phone Number Should not be same as Current Phone Number'
      )
    } else {
      setCountryCode(values?.country_code)
      let payLoad = {
        newEmail: '',
        newPhone: enteredPhone,
        country_code: values?.country_code,
      }
      setCountryCode(values?.country_code)
      let callBack = msg => {
        if (msg == 'success') {
          setPhoneModel(false)
          setPhoneOTP(true)
        }
      }
      SendOtp(stdData?.admin?._id, payLoad, callBack)
    }
  }
  const [pwd, setPwd] = useState('')
  const [pwd2, setPwd2] = useState('')
  const onChangePwd = e => {
    setPwd(e.target.value)
  }
  const onChangePwd2 = e => {
    setPwd2(e.target.value)
  }
  const handleSuccess = () => {
    studentOptedStatus()
  }
  const isPasswordValid =
  pwd?.length >= 8 &&
  /[A-Z]/.test(pwd) &&
  /[a-z]/.test(pwd) &&
  /\d/.test(pwd) &&
  /[!@#$%^&*(),.?":{}|<>]/.test(pwd) &&
  pwd === pwd2
  return (
    <SectionWrapper column>
      <TopHeader row spaceBetween alignCenter>
        <TopHeading flexStart>Manage Profile</TopHeading>
      </TopHeader>
      <StyledDivider />
      <Row>
        <Col span={5}>
          <StyledMenu defaultSelectedKeys="profile" onClick={changeTab}>
            <Menu.Item key="profile">Profile</Menu.Item>
            <StyledDividerTab />
            <Menu.Item key="password">Change Password</Menu.Item>
            <StyledDividerTab />
            <Menu.Item key="setting">Settings</Menu.Item>
            <StyledDividerTab />
            {(accessLevel === 1 || accessLevel === 3) && (
              <>
              <Menu.Item key="optout">Opt-in/Opt-out</Menu.Item>
              <StyledDividerTab />
              </>
            )}
           
          </StyledMenu>
        </Col>
        <ImageColPadding span={19}>
          {tab != undefined && tab === 'profile' && (
            <>
              <Form
                scrollToFirstError
                onFinish={submitHandler1}
                id={'profileForm'}
                form={form}
                layout="vertical"
              >
                <Row>
                  <ImageColPadding>
                    <ImageUploadWrapper
                      column
                      alignCenter
                      center
                      boarder={!file}
                    >
                      {!file && (
                        <Fragment>
                          <Control column alignCenter>
                            <Camera />
                          </Control>
                          <Control column alignCenter top={'3px'}>
                            <Control column alignCenter>
                              <SpanTest>Max file size: 2MB</SpanTest>
                            </Control>
                            <Control column alignCenter>
                              <SpanTest>Dimension: 130*130</SpanTest>
                            </Control>
                            <Control column alignCenter>
                              <SpanTest>File format: .png, .jpeg</SpanTest>
                            </Control>
                          </Control>
                        </Fragment>
                      )}
                      {file && <ImageTag src={file} />}
                    </ImageUploadWrapper>
                    {!file && (
                      <>
                        <Uploader
                          setFile={setFile}
                          showTextUploder={!file}
                          fileName={
                            studentFormData?.admin?.firstName
                              ?.toLowerCase()
                              .replace(/\s/g, '') + '_profile'
                          }
                        />
                        <NoteText>Note:</NoteText>
                        <NoteText>Max file size: 2MB</NoteText>
                        <NoteText>Dimension: 130*130</NoteText>
                        <NoteText>File format: .png, .jpeg</NoteText>
                      </>
                    )}
                    <FormItem
                      name={'profileUrl'}
                      padding={true}
                      rules={[
                        {
                          required: false,
                          message: 'Please upload a image!',
                        },
                      ]}
                    />
                  </ImageColPadding>
                  <ButtonCenterPadding>
                    {file ? (
                      <Flex>
                        <Uploader
                          isDelete={true}
                          file={file}
                          setFile={setFile}
                          showButtonUploder={!!file}
                          fileName={
                            studentFormData?.admin?.firstName
                              ?.toLowerCase()
                              .replace(/\s/g, '') + '_profile'
                          }
                        />
                        &nbsp; &nbsp;
                        <Button.Secondary
                          text="Remove"
                          onClick={onRemoveImage}
                          height={'32px'}
                        />
                      </Flex>
                    ) : null}
                  </ButtonCenterPadding>
                </Row>
                <RowPadding>
                  <LabelColPadding span={6}>
                    <InputLabel>
                      First Name *
                      {pendingData?.firstName?.value && pendingData?.firstName?.value !== studentFormData?.admin?.firstName && (
                        <Tooltip title="Data Verification Pending">
                          <PendingIcon />
                        </Tooltip>
                      )}
                    </InputLabel>
                  </LabelColPadding>
                  <Col span={10}>
                    <AntdInput
                      placeholder="First name"
                      name={'firstName'}
                      maxLength={120}
                      disabled={frozenFieldsLocal?.firstName}
                      rules={[
                        {
                          required: true,
                          message: 'Please enter first name!',
                        },
                        {
                          min: 3,
                          max: 120,
                          message:
                            'Please Enter Valid Name,Minimum 3 characters , Maximum 120 characters',
                        },
                        {
                          pattern: /^[A-Za-z\s]+$/,
                          message: 'Please enter a valid first name!',
                        },
                      ]}
                    />
                  </Col>
                </RowPadding>
                <RowPadding>
                  <LabelColPadding span={6}>
                    <InputLabel>
                      Last Name
                      {pendingData?.lastName?.value && pendingData?.lastName?.value !== studentFormData?.admin?.lastName && (
                        <Tooltip title="Data Verification Pending">
                          <PendingIcon />
                        </Tooltip>
                      )}
                    </InputLabel>
                  </LabelColPadding>
                  <Col span={10}>
                    <AntdInput
                      placeholder="Last name"
                      name={'lastName'}
                      maxLength={20}
                      disabled={frozenFieldsLocal?.lastName}
                      rules={[
                        {
                          max: 20,
                          message:
                            'Please Enter Valid Name,Maximum length is 20 characters',
                        },
                        {
                          pattern: /^[A-Za-z\s]+$/,
                          message: 'Please enter a valid last name!',
                        },
                      ]}
                    />
                  </Col>
                </RowPadding>
                <RowPadding>
                  <LabelColPadding span={6}></LabelColPadding>
                  <Col span={10}>
                    <Flex end>
                      <Button.Primary
                        htmlType="submit"
                        form={submitkey}
                        text={'Save Changes'}
                        width={'120px'}
                        padding={'10px'}
                      />
                    </Flex>
                  </Col>
                </RowPadding>
                <StyledDividerTab />
                <RowPadding>
                  <LabelColPadding span={6}>
                    <Label>
                      Email ID *
                      {pendingData?.studentPersonalProfile?._pendingFields?.primaryEmail?.value && pendingData?.studentPersonalProfile?._pendingFields?.primaryEmail?.value !== studentFormData?.admin?.email && (
                        <Tooltip title="Data Verification Pending">
                          <PendingIcon />
                        </Tooltip>
                      )}
                    </Label>
                  </LabelColPadding>
                  <Col span={10}>
                    <AntdInput
                      placeholder="eg:harry@yahoo.com"
                      name={'email'}
                      rules={[
                        {
                          required: true,
                          message: 'Please enter primary email!',
                        },
                      ]}
                      disabled={true}
                      suffix={
                        !frozenFieldsLocal?.email && (
                          <StyledSpan onClick={changeMail}>Change</StyledSpan>
                        )
                      }
                    />
                  </Col>
                </RowPadding>
                <RowPadding>
                  <LabelColPadding span={6}>
                    <Label>
                      Phone Number *
                      {pendingData?.studentPersonalProfile?._pendingFields?.phoneNumber?.value && pendingData?.studentPersonalProfile?._pendingFields?.phoneNumber?.value !== studentFormData?.admin?.phoneNumber && (
                        <Tooltip title="Data Verification Pending">
                          <PendingIcon />
                        </Tooltip>
                      )}
                    </Label>
                  </LabelColPadding>
                  <Col span={10}>
                    <Control>
                      <StyledSelectDiv>
                        <FormItem name="countryCode" width={'30%'}>
                          <AntdSelect
                            showSearch
                            id="countryId"
                            OptionData={listOfCountries}
                            width="100%"
                            disabled={true}
                            value={countryCode}
                            onChange={onCountryCodeChange}
                            bordered={false}
                            placeholder="91"
                            nameParam="phone_code"
                            valueParam="phone_code"
                            onSearch={value =>
                              getListOfCountries({
                                phoneCodeSearch: value,
                                pageLimit: 500,
                              })
                            }
                            filterOption={false}
                          />
                        </FormItem>
                      </StyledSelectDiv>
                      <StyledInputDiv>
                        <StyledInput
                          width="100%"
                          type="tel"
                          placeholder="Eg: 1010101010"
                          rules={[
                            {
                              required: true,
                              message: 'Please Enter phone number!',
                            },
                          ]}
                          name={'phoneNumber'}
                          disabled={true}
                          suffix={
                            !frozenFieldsLocal?.phoneNumber && (
                              <StyledSpan onClick={changePhone}>
                                Change
                              </StyledSpan>
                            )
                          }
                        />
                      </StyledInputDiv>
                    </Control>
                  </Col>
                </RowPadding>
              </Form>

              {emailModel && (
                <Modal
                  width={'585px'}
                  open={emailModel}
                  footer={null}
                  onCancel={handleEmailCancel}
                >
                  <RowPadding>
                    <Content alignCenter column center>
                      <Flex>
                        <img src={Emptystates} alt={'emptyState'} />
                      </Flex>
                      <MailHeading>Update Your Email ID</MailHeading>
                      <MailSubHeading>
                        You have to <b>Verify</b> your email ID to Login further
                      </MailSubHeading>
                    </Content>
                    <Form
                      style={{ width: '100%' }}
                      scrollToFirstError
                      onFinish={sendEmailOTP}
                      id={'emailForm'}
                      layout="vertical"
                    >
                      <Label>Email Address *</Label>
                      <AntdInput
                        AntdInput
                        placeholder="eg:harry@yahoo.com"
                        width="100%"
                        name="Email"
                        onChange={onEmailEntered}
                        rules={[
                          () => ({
                            validator(_, value) {
                              let isValid = IsValidEmail(value)
                              if (!isValid) {
                                return Promise.reject(
                                  new Error(`Please Enter Valid Email`)
                                )
                              }

                              return Promise.resolve()
                            },
                          }),
                        ]}
                      />

                      <DisplayPad>
                        <Button.Primary
                          htmlType="submit"
                          text={'Send Verifcation Code'}
                          width={'100%'}
                          padding={'10px'}
                        />
                      </DisplayPad>
                    </Form>
                    <MailSubHeading>
                      You will receive an OTP in your mail account to verify
                      your email address.{' '}
                    </MailSubHeading>

                    <SplitFlex row spaceBetween alignCenter>
                      <Flex flexStart>
                        <Learn href={'http://pluginlive.com'} target="_blank">
                          Learn More
                        </Learn>
                      </Flex>
                      <MailSubHeading>
                        *Terms and condition applied
                      </MailSubHeading>
                    </SplitFlex>
                  </RowPadding>
                </Modal>
              )}

              {emailOTP && (
                <Modal
                  width={'585px'}
                  open={emailOTP}
                  footer={null}
                  onCancel={handleEmailOTPCancel}
                >
                  <RowPadding>
                    <Content alignCenter column center>
                      <Flex>
                        <img src={Emptystates} alt="emptyStates" />
                      </Flex>
                      <MailHeading>Verify your Address </MailHeading>
                    </Content>

                    <MailSubHeading>
                      We will send you a 4-digit ‘One Time Password’ to your
                      email address . Please verify to proceed further.
                    </MailSubHeading>
                    <DisplayPad>
                      <MailSubHeading>
                        A verification code will be sent to{' '}
                        <b>{enteredEmail}</b>
                      </MailSubHeading>
                    </DisplayPad>
                    <OtpDiv alignCenter column>
                      <OTPHeading>Enter the OTP</OTPHeading>
                      <InputGroup>
                        <Input
                          placeholder="0"
                          width="50px"
                          type="number"
                          id="1st"
                          maxLength={1}
                          onChange={e => clickEventEmail('sec', e)}
                          onKeyDown={e => emailOTPKeyDown('1st', e)}
                          value={otpEmail?.otp1}
                        />
                        <Input
                          placeholder="0"
                          type="number"
                          id="sec"
                          width="50px"
                          maxLength={1}
                          onChange={e => clickEventEmail('third', e)}
                          onKeyDown={e => emailOTPKeyDown('sec', e)}
                          value={otpEmail?.otp2}
                        />
                        <Input
                          placeholder="0"
                          width="50px"
                          type="number"
                          id="third"
                          maxLength={1}
                          onChange={e => clickEventEmail('fourth', e)}
                          onKeyDown={e => emailOTPKeyDown('third', e)}
                          value={otpEmail?.otp3}
                        />
                        <Input
                          placeholder="0"
                          id="fourth"
                          width="50px"
                          type="number"
                          maxLength={1}
                          onChange={e => clickEventEmail('last', e)}
                          onKeyDown={e => emailOTPKeyDown('fourth', e)}
                          value={otpEmail?.otp4}
                        />
                      </InputGroup>
                      <Span>{errmsg}</Span>
                      <OTPButton onClick={() => sendEmailOTP()}>
                        Didn’t receive? &nbsp;<SpanBold>Resnd OTP</SpanBold>
                      </OTPButton>
                      {!otpEmail?.otp4 && (
                        <OTPMessage>
                          <div>
                            <Avatar size={20} src={<Check />} />
                          </div>
                          <div>OTP Sent Successfully.</div>
                        </OTPMessage>
                      )}
                    </OtpDiv>
                  </RowPadding>
                </Modal>
              )}

              {emailVerify && (
                <Modal
                  width={'585px'}
                  open={emailVerify}
                  footer={null}
                  onCancel={handleEmailVerifyCancel}
                >
                  <RowPadding>
                    <Content alignCenter column center>
                      <Flex>
                        <img src={Party} alt="partyStates" />
                      </Flex>
                      <MailHeading>Verified Successfully</MailHeading>
                      <MailSubHeading>
                        Your Email address verified successfully
                      </MailSubHeading>
                    </Content>
                  </RowPadding>
                </Modal>
              )}

              {phoneModel && (
                <Modal
                  width={'585px'}
                  open={phoneModel}
                  footer={null}
                  onCancel={handlePhoneCancel}
                >
                  <RowPadding>
                    <Content alignCenter column center>
                      <Flex>
                        <img src={phonestates} alt="phoneStates" />
                      </Flex>
                      <MailHeading>Update Your Phone Number</MailHeading>
                      <MailSubHeading>
                        You have to <b>Verify</b> your phone number to Login
                        further *
                      </MailSubHeading>
                    </Content>
                    <Form
                      style={{ width: '100%' }}
                      scrollToFirstError
                      onFinish={sendPhoneOTP}
                      id={'phoneForm'}
                      layout="vertical"
                      form={otpChangeForm}
                    >
                      <Label>Phone Address *</Label>
                      <Control>
                        <StyledSelectDiv>
                          <FormItem
                            name="country_code"
                            width={'100%'}
                            rule={[
                              {
                                required: true,
                                message: 'Required',
                              },
                            ]}
                          >
                            <AntdSelect
                              id="changeNum"
                              showSearch
                              width="100%"
                              OptionData={countryCodeList}
                              value={countryCode}
                              onChange={onCountryCodeChange}
                              bordered={false}
                              placeholder="91"
                              nameParam="phone_code"
                              valueParam="phone_code"
                              onSearch={value => getCountryCodes(value)}
                              onSelect={() => {
                                getCountryCodes('')
                              }}
                              filterOption={false}
                            />
                          </FormItem>
                        </StyledSelectDiv>
                        <StyledInputDiv>
                          <StyledInput
                            width="100%"
                            type="number"
                            placeholder="Eg: 1010101010"
                            name="Phone"
                            rules={[
                              {
                                required: true,
                                message: 'Please Enter phone number!',
                              },
                              {
                                min: 10,
                                max: 10,
                                message: 'Please enter valid phone number',
                              },
                            ]}
                            onChange={onPhoneEntered}
                          />
                        </StyledInputDiv>
                      </Control>
                      <DisplayPad>
                        <Button.Primary
                          htmlType="submit"
                          text={'Send Verification Code'}
                          width={'100%'}
                          padding={'10px'}
                        />
                      </DisplayPad>
                    </Form>
                    <MailSubHeading>
                      You will receive an OTP in your mobile to verify your
                      Phone Number.{' '}
                    </MailSubHeading>

                    <SplitFlex row spaceBetween alignCenter>
                      <Flex flexStart>
                        <Learn href={'http://pluginlive.com'} target="_blank">
                          Learn More
                        </Learn>
                      </Flex>
                      <MailSubHeading>
                        *Terms and condition applied
                      </MailSubHeading>
                    </SplitFlex>
                  </RowPadding>
                </Modal>
              )}

              {phoneOTP && (
                <Modal
                  width={'585px'}
                  open={phoneOTP}
                  footer={null}
                  onCancel={handlePhoneOTPCancel}
                >
                  <RowPadding>
                    <Content alignCenter column center>
                      <Flex>
                        <img src={phonestates} alt="phoneStates" />
                      </Flex>
                      <MailHeading>Verify your Phone Number </MailHeading>
                    </Content>

                    <MailSubHeading>
                      We will send you a 4-digit ‘One Time Password’ to your
                      Phone Number . Please verify to proceed further.
                    </MailSubHeading>
                    <DisplayPad>
                      <MailSubHeading>
                        A verification code will be sent to{' '}
                        <b>{enteredPhone}</b>
                      </MailSubHeading>
                    </DisplayPad>
                    <OtpDiv alignCenter column>
                      <OTPHeading>Enter the OTP</OTPHeading>
                      <InputGroup>
                        <Input
                          placeholder="0"
                          width="50px"
                          type="number"
                          id="1st"
                          maxLength={1}
                          onChange={e => clickEventSMS('sec', e)}
                          onKeyDown={e => phoneOTPKeyDown('1st', e)}
                          value={otpSMS?.otp1}
                        />
                        <Input
                          placeholder="0"
                          type="number"
                          id="sec"
                          width="50px"
                          maxLength={1}
                          onChange={e => clickEventSMS('third', e)}
                          onKeyDown={e => phoneOTPKeyDown('sec', e)}
                          value={otpSMS?.otp2}
                        />
                        <Input
                          placeholder="0"
                          width="50px"
                          type="number"
                          id="third"
                          maxLength={1}
                          onChange={e => clickEventSMS('fourth', e)}
                          onKeyDown={e => phoneOTPKeyDown('third', e)}
                          value={otpSMS?.otp3}
                        />
                        <Input
                          placeholder="0"
                          id="fourth"
                          width="50px"
                          type="number"
                          maxLength={1}
                          onChange={e => clickEventSMS('last', e)}
                          onKeyDown={e => phoneOTPKeyDown('fourth', e)}
                          value={otpSMS?.otp4}
                        />
                      </InputGroup>
                      <Span>{errmsg}</Span>
                      <OTPButton onClick={onChangeSendOtpSMS}>
                        Didn’t receive? &nbsp;<SpanBold>Resend OTP</SpanBold>
                      </OTPButton>
                      {!otpSMS?.otp4 && (
                        <OTPMessage>
                          <div>
                            <Avatar size={20} src={<Check />} />
                          </div>
                          <div>OTP Sent Successfully.</div>
                        </OTPMessage>
                      )}
                    </OtpDiv>
                  </RowPadding>
                </Modal>
              )}

              {phoneVerify && (
                <Modal
                  width={'585px'}
                  open={phoneVerify}
                  footer={null}
                  onCancel={handlePhoneVerifyCancel}
                >
                  <RowPadding>
                    <Content alignCenter column center>
                      <Flex>
                        <img src={Party} alt="partyStates" />
                      </Flex>
                      <MailHeading>Verified Successfully</MailHeading>
                      <MailSubHeading>
                        Your mobile number verified successfully.
                      </MailSubHeading>
                    </Content>
                  </RowPadding>
                </Modal>
              )}
            </>
          )}
          {tab === 'password' && (
            <Form
              scrollToFirstError
              onFinish={submitHandler2}
              id={'ChangePasswordForm'}
              form={formPwd}
              ref={formRef}
              layout="vertical"
            >
              <RowPadding>
                <LabelColPadding span={6}>
                  <InputLabel>Current Password *</InputLabel>
                </LabelColPadding>
                <Col span={10}>
                  <Password
                    placeholder="Enter Current Password"
                    name={'currentPwd'}
                    type={'password'}
                    maxLength={20}
                    rules={[
                      () => ({
                        validator(_, value) {
                          let isValid = validatePassword(value)
                          if (!isValid) {
                            return Promise.reject(
                              new Error(
                                `Password must contain atleast 1 letter, 1 number, 1 symbol. Minimum length is 8 characters.`
                              )
                            )
                          }
                          return Promise.resolve()
                        },
                      }),
                    ]}
                    iconRender={visible =>
                      visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                    }
                  />
                </Col>
              </RowPadding>

              <RowPadding>
                <LabelColPadding span={6}>
                  <InputLabel>New Password *</InputLabel>
                </LabelColPadding>
                <Col span={10}>
                  <Password
                    placeholder="Enter New Password"
                    name={'newPwd'}
                    maxLength={20}
                    onChange={onChangePwd}
                    rules={[
                      () => ({
                        validator(_, value) {
                          const currentPwd = formPwd.getFieldValue('currentPwd');
                            // 1. Check if current password and new password are same
                            if (value && currentPwd && value === currentPwd) {
                              return Promise.reject(
                                new Error('Current password and new password cannot be the same')
                              )
                            }
                          let isValid = validatePassword(value)
                          if (!isValid) {
                            return Promise.reject(
                              new Error(
                                `Password must contain atleast 1 letter, 1 number, 1 symbol. Minimum length is 8 characters.`
                              )
                            )
                          }
                          return Promise.resolve()
                        },
                      }),
                    ]}
                    iconRender={visible =>
                      visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                    }
                  />
                </Col>
              </RowPadding>

              <RowPadding>
                <LabelColPadding span={6}>
                  <InputLabel>Confirm Password *</InputLabel>
                </LabelColPadding>
                <Col span={10}>
                  <Password
                    placeholder="Confirm Password"
                    name={'confirmPwd'}
                    maxLength={20}
                    onChange={onChangePwd2}
                    rules={[
                      () => ({
                        validator(_, value) {
                          let isValid = validatePassword(value)
                          if (!isValid) {
                            return Promise.reject(
                              new Error(
                                `Password must contain atleast 1 letter, 1 number, 1 symbol. Minimum length is 8 characters.`
                              )
                            )
                          }
                          return Promise.resolve()
                        },
                      }),
                    ]}
                    iconRender={visible =>
                      visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                    }
                  />
                </Col>
              </RowPadding>
              <RowPadding>
                <LabelColPadding span={6}></LabelColPadding>
                <Col span={10}>
                  <Button.Primary
                    htmlType="submit"
                    text={'Save Changes'}
                    width={'100%'}
                    padding={'10px'}
                    disabled={!isPasswordValid}
                  />
                  <MessageDiv>
                    <InputLabel> Password Criteria:</InputLabel>
                    <div style={{ marginTop: '5px' }}>
                      <div
                        style={{
                          color: pwd?.length >= 8 ? '#52C41A' : '#8C8C8C',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                          marginBottom: '8px',
                        }}
                      >
                        <span style={{ fontSize: '8px' }}>●</span>
                        At least 8 characters
                      </div>
                      <div
                        style={{
                          color:
                            /[A-Z]/.test(pwd) && /[a-z]/.test(pwd)
                              ? '#52C41A'
                              : '#8C8C8C',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                          marginBottom: '8px',
                        }}
                      >
                        <span style={{ fontSize: '8px' }}>●</span>
                        Uppercase and lowercase character
                      </div>
                      <div
                        style={{
                          color: /[!@#$%^&*(),.?":{}|<>]/.test(pwd)
                            ? '#52C41A'
                            : '#8C8C8C',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                          marginBottom: '8px',
                        }}
                      >
                        <span style={{ fontSize: '8px' }}>●</span>
                        One special character
                      </div>
                      <div
                        style={{
                          color: /\d/.test(pwd) ? '#52C41A' : '#8C8C8C',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                          marginBottom: '8px',
                        }}
                      >
                        <span style={{ fontSize: '8px' }}>●</span>
                        One number
                      </div>
                      <div
                        style={{
                          color:
                            pwd && pwd2 && pwd === pwd2 ? '#52C41A' : '#8C8C8C',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                          marginBottom: '8px',
                        }}
                      >
                        <span style={{ fontSize: '8px' }}>●</span>
                        Passwords match
                      </div>
                    </div>
                  </MessageDiv>
                </Col>
              </RowPadding>
            </Form>
          )}
          {tab === 'setting' && (
            <Form
              scrollToFirstError
              onFinish={submitHandler3}
              id={'settingForm'}
              form={formsetting}
              layout="vertical"
            >
              {UserPreference?.notification_subscription?.email !=
                undefined && (
                <RowPadding>
                  <LabelColPadding span={14}>
                    <InputLabel>Email Notification *</InputLabel>
                  </LabelColPadding>
                  <Col span={10}>
                    <Switch
                      name={'email'}
                      checked={email}
                      onChange={onChangeEmail}
                    />
                  </Col>
                </RowPadding>
              )}
              <RowPadding>
                <LabelColPadding span={14}>
                  <InputLabel>Whatsapp Notification *</InputLabel>
                </LabelColPadding>
                <Col span={10}>
                  <Switch
                    name={'whatsapp'}
                    checked={whatsapp}
                    onChange={onChangeWhatsapp}
                  />
                </Col>
              </RowPadding>
              <RowPadding>
                <LabelColPadding span={6}></LabelColPadding>
                <Col span={10}>
                  <Flex end>
                    <Button.Primary
                      htmlType="submit"
                      text={'Save Changes'}
                      width={'120px'}
                      padding={'10px'}
                    />
                  </Flex>
                </Col>
              </RowPadding>
            </Form>
          )}
          {tab === 'optout' && (
            <StyledCard>
              <InnerWrapper>
                <AntdText strong>{message}</AntdText>
                <OptoutButton
                  text={actionText}
                  onClick={actionHandlers[actionType]}
                  {...(borderColor && { borderColor: true })}
                />
              </InnerWrapper>
            </StyledCard>
          )}
          <ActionRoleDrawer
            showDrawer={actionDrawer}
            setShowDrawer={setActionDrawer}
            {...actionDrawerProps}
            onApprove={handleApprove}
            onCloseClick={handleClose}
            onSuccessCloseClick={handleSuccess}
          />

          <ActionRoleDrawer
            showDrawer={confirmationModal}
            setShowDrawer={setConfirmationModal}
            description={`Are you sure you want to withdraw your ${
              isOptOut == 'OptedInPending' ? 'opt-in' : 'opt-out'
            }?
`}
            handleCloseDrawer={handleConfirm}
            onCloseClick={handleCloseDrawer}
          />
          <SuccessModal
            showDrawer={successModal}
            setShowDrawer={setSuccessModal}
            description={statusMessage}
            Icon={SuccessIcon}
            handleCloseDrawer={handleSuccess}
          />
        </ImageColPadding>
      </Row>
    </SectionWrapper>
  )
}
export default ManageProfile
